import React, { FunctionComponent } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  ButtonPrimary,
  ButtonSecondaryMinus,
} from '@common/components/buttons';
import { CustomModal } from '@common/components/fragments/CustomModal';
import { TextInput } from '@common/components/inputs';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  invoiceNumber: string | number;
  onConfirm: (reason: string) => Promise<void> | void;
  isLoading?: boolean;
};

type FormValues = { reason: string };

export const IgnoreInvoiceModal: FunctionComponent<Props> = ({
  isOpen,
  onRequestClose,
  invoiceNumber,
  onConfirm,
  isLoading = false,
}) => {
  const { control, handleSubmit, formState, reset } = useForm<FormValues>({
    defaultValues: { reason: '' },
  });

  const closeModal = () => {
    reset();
    onRequestClose();
  };

  const onSubmit = handleSubmit(async ({ reason }) => {
    await onConfirm(reason);
    closeModal();
  });

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <CustomModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick
      >
        <div className="flex flex-row w-[700px] bg-color-light-grey py-[20px]">
          <div className="flex-auto ml-[25px] text-xl2">
            Ignorer la facture {invoiceNumber}
          </div>
          <Button
            onClick={closeModal}
            custom
            className="mr-[25px] justify-self-end"
          >
            X
          </Button>
        </div>
        <form className="p-5 flex flex-col gap-4" onSubmit={onSubmit}>
          <Controller
            control={control}
            name="reason"
            rules={{ required: true }}
            render={({ field: { value, onChange } }) => (
              <TextInput
                textarea
                label="Motif (requis)"
                onChange={onChange}
                value={value}
                errorText={
                  formState.errors.reason ? 'Champ obligatoire' : undefined
                }
              />
            )}
          />
          <div className="flex gap-2 justify-end">
            <ButtonSecondaryMinus onClick={closeModal}>
              Annuler
            </ButtonSecondaryMinus>
            <ButtonPrimary
              type="submit"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Confirmer
            </ButtonPrimary>
          </div>
        </form>
      </CustomModal>
    </div>
  );
};
